import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { FilterCheckboxIcon } from 'apps/sigma2-ui/src/filters-v2/components/FilterCheckboxIcon';
import { FilterItemWrapper } from 'apps/sigma2-ui/src/filters-v2/components/FilterItemWrapper';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import cn from 'classnames';

export interface FilterSelectAllItemProps {
  /**
   * Callback when the button is clicked
   * @param action - 'remove' or 'add'
   */
  onClick: (action: 'remove' | 'add') => void;

  /**
   * The current checked status
   */
  checked: boolean;
}

export const FilterSelectAllItem = ({
  onClick,
  checked,
}: FilterSelectAllItemProps) => {
  const language = useLanguage();

  return (
    <TouchTarget
      content={({ hovered }) => (
        <FilterItemWrapper highlight={hovered}>
          <Spacing
            direction={'horizontal'}
            size={'sm'}
            className={'items-center -ml-2'}
          >
            <FilterCheckboxIcon checked={checked} hovered={hovered} />
            <S2Typography
              variant={'body-7'}
              translatedContent={language.selectAll()}
              textColorVariant={'gray-900'}
              truncate={true}
              flex={true}
            />
          </Spacing>
        </FilterItemWrapper>
      )}
      behavior={{
        type: 'onClick',
        onClick: () => {
          onClick(checked ? 'remove' : 'add');
        },
      }}
      className={'filter-select-all-item'}
      dataExtras={{
        checked: checked ? '1' : '0',
      }}
    />
  );
};
